/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { HistoryDtoUser } from './HistoryDtoUser';
import {
    HistoryDtoUserFromJSON,
    HistoryDtoUserFromJSONTyped,
    HistoryDtoUserToJSON,
} from './HistoryDtoUser';
import type { UserStateOfUse } from './UserStateOfUse';
import {
    UserStateOfUseFromJSON,
    UserStateOfUseFromJSONTyped,
    UserStateOfUseToJSON,
} from './UserStateOfUse';
import type { UserAccountType } from './UserAccountType';
import {
    UserAccountTypeFromJSON,
    UserAccountTypeFromJSONTyped,
    UserAccountTypeToJSON,
} from './UserAccountType';

/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    readonly isDeleted?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    readonly deleterUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    readonly deletionTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    middleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    emailAddress: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastLoginTime?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    profilePictureId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    readonly fullName: string;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserDto
     */
    assignedRoles: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDto
     */
    assignedRolesDisplayNames?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    rolesUpdated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    description?: string | null;
    /**
     * 
     * @type {UserAccountType}
     * @memberof UserDto
     */
    accountType?: UserAccountType;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    mobileNumber?: string | null;
    /**
     * 
     * @type {UserStateOfUse}
     * @memberof UserDto
     */
    state?: UserStateOfUse;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof UserDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof UserDto
     */
    possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof UserDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    lastSeen?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    lastSeenNow?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    firstSignIn?: boolean;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UserDto
     */
    creatorUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UserDto
     */
    lastModifierUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {HistoryDtoUser}
     * @memberof UserDto
     */
    editingUser?: HistoryDtoUser | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDto
     */
    eulaAccepted?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof UserDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    $type?: UserDtoTypeEnum;
}


/**
 * @export
 */
export const UserDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationUsersDtoUserDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Users.Dto.UserDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UserDtoTypeEnum = typeof UserDtoTypeEnum[keyof typeof UserDtoTypeEnum];



/**
 * Check if a given object implements the UserDto interface.
 */
export function instanceOfUserDto(value?: unknown): value is UserDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UserDtoTypeEnum)[0];
}

export function UserDtoFromJSON(json: any): UserDto {
    return UserDtoFromJSONTyped(json, false);
}

export function UserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'isDeleted': json['isDeleted'] == null ? undefined : json['isDeleted'],
        'deleterUserId': json['deleterUserId'] == null ? undefined : json['deleterUserId'],
        'deletionTime': json['deletionTime'] == null ? undefined : json['deletionTime'],
        'userName': json['userName'],
        'title': json['title'] == null ? undefined : json['title'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'emailAddress': json['emailAddress'],
        'lastLoginTime': json['lastLoginTime'] == null ? undefined : json['lastLoginTime'],
        'profilePictureId': json['profilePictureId'] == null ? undefined : json['profilePictureId'],
        'fullName': json['fullName'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'assignedRoles': json['assignedRoles'],
        'assignedRolesDisplayNames': json['assignedRolesDisplayNames'] == null ? undefined : json['assignedRolesDisplayNames'],
        'rolesUpdated': json['rolesUpdated'] == null ? undefined : json['rolesUpdated'],
        'description': json['description'] == null ? undefined : json['description'],
        'accountType': json['accountType'] == null ? undefined : UserAccountTypeFromJSON(json['accountType']),
        'mobileNumber': json['mobileNumber'] == null ? undefined : json['mobileNumber'],
        'state': json['state'] == null ? undefined : UserStateOfUseFromJSON(json['state']),
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'lastSeen': json['lastSeen'] == null ? undefined : json['lastSeen'],
        'lastSeenNow': json['lastSeenNow'] == null ? undefined : json['lastSeenNow'],
        'firstSignIn': json['firstSignIn'] == null ? undefined : json['firstSignIn'],
        'creatorUser': json['creatorUser'] == null ? undefined : HistoryDtoUserFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : HistoryDtoUserFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : HistoryDtoUserFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'eulaAccepted': json['eulaAccepted'] == null ? undefined : json['eulaAccepted'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UserDtoToJSON(value?: Omit<UserDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'isDeleted'|'deleterUserId'|'deletionTime'|'fullName'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'userName': value['userName'],
        'title': value['title'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'emailAddress': value['emailAddress'],
        'lastLoginTime': value['lastLoginTime'],
        'profilePictureId': value['profilePictureId'],
        'iuid': value['iuid'],
        'phoneNumber': value['phoneNumber'],
        'assignedRoles': value['assignedRoles'],
        'assignedRolesDisplayNames': value['assignedRolesDisplayNames'],
        'rolesUpdated': value['rolesUpdated'],
        'description': value['description'],
        'accountType': UserAccountTypeToJSON(value['accountType']),
        'mobileNumber': value['mobileNumber'],
        'state': UserStateOfUseToJSON(value['state']),
        'isAvailable': value['isAvailable'],
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'possibleActions': value['possibleActions'] == null ? undefined : ((value['possibleActions'] as Array<any>).map(PossibleActionDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'lastSeen': value['lastSeen'],
        'lastSeenNow': value['lastSeenNow'],
        'firstSignIn': value['firstSignIn'],
        'creatorUser': HistoryDtoUserToJSON(value['creatorUser']),
        'lastModifierUser': HistoryDtoUserToJSON(value['lastModifierUser']),
        'editingUser': HistoryDtoUserToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'eulaAccepted': value['eulaAccepted'],
        'origin': EntityOriginToJSON(value['origin']),
        '$type': value['$type'],
    });
}

